import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { logout } from '../firebase';
import './Navbar.css';

function Navbar({ user }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [desktopMenuOpen, setDesktopMenuOpen] = useState(false);
  const isHosting = location.pathname.includes('/hosting');
  
  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      alert('Logout failed');
    }
  };

  const handleToggleMode = () => {
    if (isHosting) {
      navigate('/');
    } else {
      navigate('/hosting');
    }
    setMenuOpen(false);
    setDesktopMenuOpen(false);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const toggleDesktopMenu = () => {
    setDesktopMenuOpen(!desktopMenuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setDesktopMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand" onClick={closeMenu}>
          <img src="/logo.png" alt="StayCombinator" className="navbar-logo-img" />
          <span className="navbar-logo-text">StayCombinator</span>
        </Link>
        
        <div className="navbar-menu">
          <button onClick={handleToggleMode} className="hosting-btn">
            {isHosting ? 'Switch to Traveling' : 'Switch to Hosting'}
          </button>
          {user.photoURL && (
            <div className="avatar-dropdown-container">
              <button className="user-avatar-btn" onClick={toggleDesktopMenu}>
                <img src={user.photoURL} alt={user.displayName} className="user-avatar" />
              </button>
              {desktopMenuOpen && (
                <>
                  <div className="dropdown-overlay" onClick={closeMenu}></div>
                  <div className="avatar-dropdown-menu">
                    <div className="dropdown-user-info">
                      <img src={user.photoURL} alt={user.displayName} className="dropdown-avatar" />
                      <span className="dropdown-user-name">{user.displayName || user.email}</span>
                    </div>
                    <hr className="dropdown-divider" />
                    <Link to="/profile" className="dropdown-item" onClick={closeMenu}>
                      👤 Profile
                    </Link>
                    <Link to="/settings" className="dropdown-item" onClick={closeMenu}>
                      ⚙️ Settings
                    </Link>
                    <button onClick={handleToggleMode} className="dropdown-item">
                      {isHosting ? '🏘️ Switch to Traveling' : '🏘️ Switch to Hosting'}
                    </button>
                    {!isHosting && (
                      <>
                        <Link to="/saved" className="dropdown-item" onClick={closeMenu}>
                          ❤️ Saved
                        </Link>
                        <Link to="/trips" className="dropdown-item" onClick={closeMenu}>
                          ✈️ Trips
                        </Link>
                      </>
                    )}
                    <hr className="dropdown-divider" />
                    <button onClick={handleLogout} className="dropdown-item logout">
                      🚪 Logout
                    </button>
                  </div>
                </>
              )}
            </div>
          )}
        </div>

        {user.photoURL && (
          <button className="user-avatar-mobile-btn" onClick={toggleMenu}>
            <img src={user.photoURL} alt={user.displayName} className="user-avatar-mobile" />
          </button>
        )}

        {menuOpen && (
          <>
            <div className="mobile-menu-overlay" onClick={closeMenu}></div>
            <div className="mobile-menu">
              <div className="mobile-menu-content">
                {!isHosting && (
                  <Link to="/" className="mobile-menu-item" onClick={closeMenu}>
                    🏠 Browse
                  </Link>
                )}
                <button onClick={handleToggleMode} className="mobile-menu-item">
                  {isHosting ? '🏘️ Switch to Traveling' : '🏘️ Switch to Hosting'}
                </button>
                {!isHosting && (
                  <>
                    <Link to="/saved" className="mobile-menu-item" onClick={closeMenu}>
                      ❤️ Saved
                    </Link>
                    <Link to="/trips" className="mobile-menu-item" onClick={closeMenu}>
                      ✈️ Trips
                    </Link>
                  </>
                )}
                <Link to="/profile" className="mobile-menu-item" onClick={closeMenu}>
                  👤 Profile
                </Link>
                <Link to="/settings" className="mobile-menu-item" onClick={closeMenu}>
                  ⚙️ Account Settings
                </Link>
                <hr className="mobile-menu-divider" />
                {user.photoURL && (
                  <div className="mobile-menu-user">
                    <img src={user.photoURL} alt={user.displayName} className="mobile-menu-avatar" />
                    <span className="mobile-menu-label">{user.displayName || user.email}</span>
                  </div>
                )}
                <button onClick={handleLogout} className="mobile-menu-item logout">
                  🚪 Logout
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
